/**
 * 모바일 QR 참석 등록 (임시 세션)
 * - SaveTraCustom02SessionSign: SessionId는 평문 GUID (JWT 없음)
 * - UserNm/JobType/TpaUserId/Remark: 서버에서 길이/필수값 검증
 */
export const M_TRA_SIGN_Schema = {
  mapper: {
    saveTraCustom02SessionSign1: {
      SessionId: (ctx) => String(ctx.sessionId ?? '').trim(),
      UserNm: (ctx) => String(ctx.userNm ?? '').trim(),
      JobType: (ctx) => String(ctx.jobType ?? '').trim(),
      TpaUserId: (ctx) => String(ctx.tpaUserId ?? '').trim(),
      Remark: (ctx) => String(ctx.remark ?? '').trim(),
    },
  },
};

